import { useLazyQuery, useMutation } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import ADD_NEWSLETTER from "mutations/newsletters/addNewsletter";
import GET_NEWSLETTERS from "queries/newsletters/getNewsletters";
import { useHistory } from "react-router-dom";
import Add from "./Add";
const usePrepareComponent = () => {
    const history = useHistory();
    const [addContent, { loading }] = useMutation(ADD_NEWSLETTER, {
        refetchQueries: [GET_NEWSLETTERS]
    });
    const [getContents] = useLazyQuery(GET_NEWSLETTERS);
    const onCancel = () => {
        history.push(`/newsletters`);
    };
    const onSave = (itemAdd) => {
        addContent({
            onCompleted: () => {
                getContents({
                    fetchPolicy: "network-only",
                    onCompleted: () => {
                        history.push(`/newsletters`);
                    }
                });
            },
            variables: {
                newsletterAddInput: {
                    ...itemAdd,
                    emailPreferences: itemAdd.emailPreferences ?? "",
                    name: itemAdd.name ?? "",
                    placeholders: itemAdd.placeholders
                        ? JSON.stringify(itemAdd.placeholders)
                        : undefined
                }
            }
        });
    };
    return {
        loading,
        onCancel,
        onSave
    };
};
export default prepareComponent(usePrepareComponent)(Add);
